<template>
  <!-- Alert Account Delete Modal -->
  <div
    class="modal fade done"
    id="alert2Modal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="close-model-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>

        <div class="content-model-me">
          <div class="modal-header d-flex flex-column ">
            <h2 class="section-title mb-3">هل تود بالفعل حذف الحساب؟</h2>
            <h6 class="text-danger text-center">
              يرجى الانتباه ! في حالة حذف الحساب سيتم حذف جميع الاعلانات والبنرات الخاصة بك
            </h6>
          </div>

          <div class="modal-body">
            <div class="delete-anim-wrap" aria-hidden="true">
              <div class="delete-ring ring-one"></div>
              <div class="delete-ring ring-two"></div>
              <div class="delete-core">
                <i class="fa-regular fa-trash-can delete-icon"></i>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="main-btn red md up"
              aria-label="Close"
              @click="deleteAcc()"
            >
              نعم
            </button>
            <button
              class="main-btn md up"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              لا
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from 'axios'
export default defineComponent({
  name: "removeAccountModal",
  methods: {
    async  deleteAcc(){
      await axios.delete('delete-account', {
        headers:{
          Authorization:  `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then( (res)=>{
        if( res.data.key == "success" ){
          this.$swal({
              icon: 'success',
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,

          });

          localStorage.removeItem('adsImages');
          localStorage.removeItem('ad_name');
          localStorage.removeItem('ad_price');
          localStorage.removeItem('ad_category_id');
          localStorage.removeItem('ad_city_id');
          localStorage.removeItem('ad_details');
          localStorage.removeItem('ad_contact_method');
          localStorage.removeItem('ad_status');
          localStorage.removeItem('banner_img');
          localStorage.removeItem('banner_text');
          localStorage.removeItem('banner_video');
          localStorage.removeItem('bannerOrAd');
          sessionStorage.removeItem('token')
          this.$router.push('/');
          setTimeout(() => {  
            location.reload();
          }, 2000);
        }else{
          this.$swal({
              icon: 'error',
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,

          });
        }
      } )
    }
  },

  components: {},
});
</script>
<style scoped>
.delete-anim-wrap {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid rgba(220, 38, 38, 0.18);
  background: rgba(254, 242, 242, 0.9);
  animation: deletePulse 2.2s ease-out infinite;
}

.ring-two {
  animation-delay: 0.8s;
}

.delete-core {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 14px 30px rgba(220, 38, 38, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: deleteFloat 1.8s ease-in-out infinite;
}

.delete-icon {
  color: #ffffff;
  font-size: 40px;
  animation: deleteWiggle 1.8s ease-in-out infinite;
}

@keyframes deletePulse {
  0% {
    transform: scale(0.72);
    opacity: 0.8;
  }
  70% {
    transform: scale(1.18);
    opacity: 0;
  }
  100% {
    transform: scale(1.18);
    opacity: 0;
  }
}

@keyframes deleteFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

@keyframes deleteWiggle {
  0%, 100% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(-7deg);
  }
  40% {
    transform: rotate(6deg);
  }
  60% {
    transform: rotate(-4deg);
  }
  80% {
    transform: rotate(3deg);
  }
}
</style>
